import React from 'react';
import { ImgApex, ImgBootstrap, ImgFormik, ImgStorybook } from '../components/Images';

const SectionIntegrated = () => (
	<div
		id='integrated'
		className='row scroll-margin g-4'
		style={{ paddingTop: '10rem', paddingBottom: '10rem' }}>
		<div className='col-12 text-center display-4 fw-bold'>
			<span>Integrated</span>
		</div>
		<div className='col-12 d-flex justify-content-center'>
			<div className='text-muted lead'>
				You can easily use any template you want for the pages you create.
			</div>
		</div>
		<div className='col-lg-8 offset-lg-2 mt-5'>
			<div className='row h-100'>
				<div className='col-lg-6 mb-5'>
					<div className='ratio ratio-16x9 mb-4'>
						<img
							src={ImgBootstrap}
							alt=''
							width='100%'
							height='auto'
							className='object-fit-contain p-3'
						/>
					</div>
					<div className='display-6 fw-bold mb-4 position-relative'>
						Bootstrap <span className='text-primary'>5</span>
						<span className='fs-3 position-absolute top-0 translate-middle-y'>
							<span className='badge bg-success shadow'>NEW</span>
						</span>
					</div>
					<p className='fs-5 mb-5'>
						It is compatible with the design with <strong>Reactstrap</strong> logic and
						new components have been created with <em>Bootstrap 5</em> and you can make
						changes in them. The usage of all components in the{' '}
						<strong>storybook</strong> are available.
					</p>
				</div>
				<div className='col-lg-6 mb-5'>
					<div className='ratio ratio-16x9 mb-4'>
						<img
							src={ImgStorybook}
							alt=''
							width='100%'
							height='auto'
							className='object-fit-contain p-3'
						/>
					</div>
					<div className='display-6 fw-bold mb-4'>Storybook</div>
					<p className='fs-5 mb-5'>
						You can share how the components are used and your customized stories with
						your teammates. You can also copy the jsx and html outputs and paste them
						directly into your project.
					</p>
				</div>
				<div className='col-lg-6 mb-5'>
					<div className='ratio ratio-16x9 mb-4'>
						<img
							src={ImgFormik}
							alt=''
							width='100%'
							height='auto'
							className='object-fit-contain p-3'
						/>
					</div>
					<div className='display-6 fw-bold mb-4'>Formik</div>
					<p className='fs-4 mb-3'>Build forms in React, without the tears 🥳</p>
					<p className='fs-5 mb-5'>
						Yes! You will have a lot of fun while dealing with forms, you will get the
						results you want without contradicting the design of the project. In fact,
						we have another good news, validation is also included.
					</p>
				</div>
				<div className='col-lg-6 mb-5'>
					<div className='ratio ratio-16x9 mb-4'>
						<img
							src={ImgApex}
							alt=''
							width='100%'
							height='auto'
							className='object-fit-contain p-3'
						/>
					</div>
					<div className='display-6 fw-bold mb-4'>Apex Chart</div>
					<p className='fs-5 mb-5'>
						You can easily include 16 different types of graphics in your project and
						have harmonious designs.
					</p>
				</div>
			</div>
		</div>
	</div>
);

export default SectionIntegrated;
